module.exports = __webpack_public_path__ + "img/logo-playstation.98dc8471.svg";